import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

export const greetAgenticBriefConversation = async (conversationId: string): Promise<void> => {
    const url = pathfinder('ai_agents_greet_conversation', {
        agentId: 'job-post-brief',
        id: conversationId,
        apiVersion: 'v1',
    });

    await axios.post(url, {});
};
